















































import Vue from 'vue'
import SectionTitle from '@/components/SectionTitle.vue'

const CustomizeVoice = Vue.extend({
  components: {
    SectionTitle
  },
  computed: {
    voiceItems (): any {
      return this.$t('service.items')
    }
  },
  methods: {
    type (index: number): string {
      if (index % 2 === 0) {
        return 'client'
      } else {
        return 'tagging'
      }
    },
    avatar (index: number): string {
      if (index % 2 === 0) {
        return require('@/assets/image/service/client.png')
      } else {
        return require('@/assets/image/service/tagging.png')
      }
    }
  }
})
export default CustomizeVoice
